
import vipLogo from "@/assets/vip-logo.jpg";
import { useLanguage } from "@/i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer id="contact" className="bg-card border-t border-border/50 py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={vipLogo} alt="VIP Fitness Club" className="h-12 w-auto" width={48} height={48} loading="lazy" />
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-primary">
                  VIP FITNESS
                </span>
                <span className="font-heading text-xs font-medium text-muted-foreground tracking-widest">
                  CLUB
                </span>
              </div>
            </div>
            <p className="text-muted-foreground text-sm mb-6">
              {t.footer.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-bold text-foreground mb-4 uppercase">
              {t.footer.quickLinks}
            </h4>
            <ul className="space-y-3">
              {[t.nav.classes, t.nav.trainers, t.nav.pricing, t.footer.schedule, t.footer.blog].map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  >
                    {link}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/admin/login"
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  Admin Login
                </a>
              </li>
              <li>
                <a
                  href="/owner/login"
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  Owner Login
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-heading text-lg font-bold text-foreground mb-4 uppercase">
              {t.footer.hours}
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex justify-between text-muted-foreground">
                <span>{t.footer.monSun}</span>
                <span className="text-foreground">7:00 AM - 21:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/50 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            {t.footer.copyright}
          </p>
          <div className="flex gap-6 text-sm text-muted-foreground">
            <a href="#" className="hover:text-primary transition-colors">
              {t.footer.privacy}
            </a>
            <a href="#" className="hover:text-primary transition-colors">
              {t.footer.terms}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
